"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _grid = require("../../fuse-responsive-grid/src/grid");
var _config = _interopRequireDefault(require("./config"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var StyledSpacingWrapper = _styledComponents["default"].div.attrs({
  className: 'fuse-spacing-wrapper'
}).withConfig({
  displayName: "styled-spacing-wrapper__StyledSpacingWrapper",
  componentId: "sc-l0df37-0"
})(["margin-bottom:", ";@media screen and (min-width:", "){margin-bottom:", ";}@media screen and (min-width:", "){margin-bottom:", ";}"], function (_ref) {
  var marginBottom = _ref.marginBottom;
  return marginBottom ? _config["default"][marginBottom].xxs : _config["default"].l.xxs;
}, _grid.gridConfig.m.minWidth, function (_ref2) {
  var marginBottom = _ref2.marginBottom;
  return marginBottom ? _config["default"][marginBottom].m : _config["default"].l.m;
}, _grid.gridConfig.l.minWidth, function (_ref3) {
  var marginBottom = _ref3.marginBottom;
  return marginBottom ? _config["default"][marginBottom].l : _config["default"].l.l;
});
var _default = exports["default"] = StyledSpacingWrapper;